/* eslint-disable */
// This file is auto generated, do not edit!

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSJSON: { input: unknown; output: unknown; }
};

export type AccountEventTicketStatus =
  | 'Active'
  | 'Expired'
  | 'Flagged'
  | 'Generating'
  | 'Scanned'
  | 'Voided';

export type ApplePayCheckoutInput = {
  applePayToken: Scalars['AWSJSON']['input'];
  orderId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
};

export type BillingAddress = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CartAddress = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CartCoupon = {
  code: Scalars['String']['input'];
  couponType?: InputMaybe<CouponType>;
};

export type CartCreateInput = {
  couponCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holdToken?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<CartItemInput>>>;
};

export type CartItemInput = {
  bookObjects?: InputMaybe<Array<Scalars['String']['input']>>;
  catalogueItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reservationToken?: InputMaybe<Scalars['String']['input']>;
  subItems?: InputMaybe<Array<CartItemInput>>;
};

export type CartItemState =
  | 'Available'
  | 'OutOfStock'
  | 'Unavailable';

export type CartState =
  | 'Active'
  | 'Expired'
  | 'Merged'
  | 'Ordered';

export type CartUpdateAction = {
  action: CartUpdateActionEnum;
  address?: InputMaybe<CartAddress>;
  couponCodes?: InputMaybe<Array<CartCoupon>>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  items?: InputMaybe<Array<CartItemInput>>;
  newQuantity?: InputMaybe<Scalars['Int']['input']>;
  parentItemId?: InputMaybe<Scalars['ID']['input']>;
  saudiRewardsId?: InputMaybe<Scalars['String']['input']>;
  subItemId?: InputMaybe<Scalars['ID']['input']>;
  subItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subItems?: InputMaybe<Array<CartItemInput>>;
};

export type CartUpdateActionEnum =
  | 'AddCouponCode'
  | 'AddItems'
  | 'AddSubItems'
  | 'ChangeBillingAddress'
  | 'ChangeItemQuantity'
  | 'ChangeSubItemQuantity'
  | 'RemoveCouponCode'
  | 'RemoveItems'
  | 'RemoveSubItems'
  | 'ReplaceItems';

export type CartUpdateInput = {
  action: CartUpdateAction;
  version: Scalars['Int']['input'];
};

export type CouponType =
  | 'LoyaltyCoupon'
  | 'RegularCoupon';

export type DiscountedType =
  | 'Absolute'
  | 'Percentage';

export type EligiblePaymentMethod =
  | 'ApplePay'
  | 'CreditCard'
  | 'TabbyPay';

export type EventSaleStatus =
  | 'Closed'
  | 'Open';

export type LoyaltyBurnPointsInput = {
  cartId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  memberPin: Scalars['String']['input'];
  points: Scalars['Float']['input'];
};

export type LoyaltyDeleteBurnPointsInput = {
  cartId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};

export type LoyaltySessionState =
  | 'cancelled'
  | 'closed'
  | 'open'
  | 'partially_returned';

export type MarketplaceListingState =
  | 'Active'
  | 'Cancelled'
  | 'Expired'
  | 'Purchased';

export type MarketplaceTransactionState =
  | 'Cancelled'
  | 'Closed'
  | 'Expired'
  | 'Open';

export type OrderCreateInput = {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  cartId: Scalars['ID']['input'];
  custom?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  orderType: OrderType;
  paymentDetails: OrderPaymentDetails;
  preferredLanguageCode?: InputMaybe<Scalars['String']['input']>;
  preferredTimezoneCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OrderPaymentDetails = {
  applePayDetails?: InputMaybe<OrderPaymentDetailsApplePay>;
  paymentMethod: PaymentMethod;
  returnUrls: OrderPaymentReturnUrls;
};

export type OrderPaymentDetailsApplePay = {
  domain: Scalars['String']['input'];
  validationUrl: Scalars['String']['input'];
};

export type OrderPaymentMethod =
  | 'ApplePay'
  | 'Checkout'
  | 'FreeOfCharge'
  | 'TabbyPay';

export type OrderPaymentReturnUrls = {
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  failedUrl?: InputMaybe<Scalars['String']['input']>;
  successUrl: Scalars['String']['input'];
};

export type OrderSaudiRewardsType =
  | 'Burn'
  | 'Earn';

export type OrderStateEnum =
  | 'AwaitingDelivery'
  | 'AwaitingPayment'
  | 'CancelledByCustomer'
  | 'CancelledBySeller'
  | 'Completed'
  | 'Created'
  | 'Declined'
  | 'Expired'
  | 'FullyRefunded'
  | 'PartiallyRefunded';

export type OrderType =
  | 'ExternalPayment'
  | 'FreeOfCharge'
  | 'OnlinePayment';

export type PaymentMethod =
  | 'ApplePay'
  | 'Checkout'
  | 'TabbyPay';

export type PayoutState =
  | 'Completed'
  | 'Created'
  | 'Failed'
  | 'Pending'
  | 'Processing';

export type SeatingObjectType =
  | 'booth'
  | 'seat'
  | 'table';

export type SellerAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
};

export type SellerApprovalState =
  | 'Approved'
  | 'Declined'
  | 'PendingRegistration'
  | 'PendingReview'
  | 'Undefined';

export type SellerBankAccountCreateInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  billingAddressLine1: Scalars['String']['input'];
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine3?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
};

export type SellerKycDocumentCreateInput = {
  documentType: SellerKycDocumentType;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  mediaDocumentId: Scalars['ID']['input'];
};

export type SellerKycDocumentType =
  | 'DriverLicense'
  | 'NationalIdCard'
  | 'Passport'
  | 'ProofOfAddress'
  | 'ResidencePermit';

export type SellerKycDocumentUploadLinkInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type SellerListedUpdateStatusInput = {
  eventId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  stateId: MarketplaceListingState;
};

export type SellerSignupInput = {
  address?: InputMaybe<SellerAddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ShippingAddress = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type SimulateLoyaltyCartItemInput = {
  catalogueItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type TabbyPrescoringInput = {
  cartId: Scalars['String']['input'];
  cartVersion: Scalars['Int']['input'];
  eventId: Scalars['String']['input'];
};

export type TicketCustomDelivery =
  | 'postal'
  | 'whatsapp';

export type TicketType =
  | 'CreditWallet'
  | 'EventAccess'
  | 'GroupTicket'
  | 'Parking';

export type TransferAcceptInput = {
  transferId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type TransferCancelInput = {
  transferId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type TransferCreateInput = {
  eventId: Scalars['ID']['input'];
  receiverName: Scalars['String']['input'];
  ticketIds: Array<Scalars['ID']['input']>;
};

export type TransferSource =
  | 'AdminDashboard'
  | 'DistributionPortal'
  | 'NOFOMO'
  | 'OrderCompletion'
  | 'Reseller';

export type TransferStatus =
  | 'Cancelled'
  | 'Completed'
  | 'Expired'
  | 'Pending';

export type BookObjectInfoFragment = { label: string, objectType: SeatingObjectType, parent?: string | undefined, section?: string | undefined, own: string };

export type CartSubItemFragment = { id: string, quantity: number };

export type CartItemFragment = { id: string, catalogueItemId: string, quantity: number, bookObjects?: Array<string> | undefined, state?: CartItemState | undefined, discountedItemPrice: MoneyInfoFragment, name: TranslatedTextFragment, originalItemPrice: MoneyInfoFragment, subItems?: Array<CartSubItemFragment> | undefined, freeItems?: Array<CartSubItemFragment> | undefined, subtotalPrice: MoneyInfoFragment, totalPrice: MoneyInfoFragment, bookedInfo?: Array<BookObjectInfoFragment> | undefined };

export type CartFragment = { id: string, cartState: CartState, version: number, cartDiscountPrice: MoneyInfoFragment, couponCodes: Array<CouponCodeFragment>, subtotalPrice: MoneyInfoFragment, subtotalPriceExcluding: MoneyInfoFragment, totalPrice: MoneyInfoFragment, totalPriceExcluding: MoneyInfoFragment, vatAmount: MoneyInfoFragment, productsDiscountValue: MoneyInfoFragment, items?: Array<CartItemFragment> | undefined, modifiers: Array<{ causedByLoyaltyTier?: string | undefined, name: string, value: number, type: string }>, seatedHoldToken?: { token: string, expiresAt: string } | undefined };

export type CouponCodeFragment = { code: string, couponType: CouponType, discountValue: MoneyInfoFragment };

export type EventCategoryFragment = { id: string, name: TranslatedTextFragment, tickets?: Array<TicketFragment> | undefined };

export type TranslatedImageUrlFragment = { url: TranslatedTextFragment };

export type ImageUrlFragment = { url: string };

export type LoyaltyEffectFragment = { name: string, type: string, value: number };

export type MoneyInfoFragment = { amount: number, currency: string };

export type OrderCheckoutFragment = { orderId: string, paymentLink?: string | undefined, validationResult?: string | undefined };

export type OrderTicketFragment = { id: string, orderItemId: string };

export type TicketOrderSubItemFragment = { id: string, quantity: number, coverImage?: { url: string } | undefined, name: TranslatedTextFragment };

export type TicketOrderItemFragment = { id: string, quantity: number, coverImage?: { url: string } | undefined, name: TranslatedTextFragment, subItems?: Array<TicketOrderSubItemFragment> | undefined, freeItems?: Array<TicketOrderSubItemFragment> | undefined };

export type OrderCustomFragment = { saudiRewards?: Array<{ type?: OrderSaudiRewardsType | undefined, points?: number | undefined, membershipId?: string | undefined }> | undefined };

export type AffiliateSaleFragment = { id: string, orderId: string, partnerId: string };

export type OrderFragment = { id: string, eventId: string, cartId: string, paymentMethod: OrderPaymentMethod, state: OrderStateEnum, couponCodes: Array<CouponCodeFragment>, items: Array<CartItemFragment>, totalPrice: MoneyInfoFragment, subtotalPrice: MoneyInfoFragment, vatAmount: MoneyInfoFragment, cartDiscountPrice: MoneyInfoFragment, productsDiscountValue: MoneyInfoFragment, totalPriceExcluding: MoneyInfoFragment, orderTickets: Array<OrderTicketFragment>, custom?: OrderCustomFragment | undefined, affiliateSales?: Array<AffiliateSaleFragment> | undefined };

export type PerkFragment = { id: string, name: TranslatedTextFragment };

export type TranslatedTextFragment = { en?: string | undefined, ar?: string | undefined };

export type TicketFragment = { id: string, isExternalForm: boolean, name: TranslatedTextFragment, description: TranslatedTextFragment, perks?: Array<PerkFragment> | undefined, extraItems?: Array<TicketEmbedFragment> | undefined, externalFormUrl?: TranslatedTextFragment | undefined, timeslots?: Array<{ dateTimeRange: { start: string } }> | undefined, seatingData?: { seatingCategoryKey: string, seatingChartEventOrSeasonId: string } | undefined };

export type TicketEmbedFragment = { id: string, name: TranslatedTextFragment, description: TranslatedTextFragment, perks?: Array<PerkFragment> | undefined };

export type TransferFragment = { id: string, eventId: string, timeslotIds?: Array<string> | undefined, status: TransferStatus, receiverName?: string | undefined, receiverEmail?: string | undefined, senderName?: string | undefined, senderEmail?: string | undefined, shareCode: string, version: number, tickets: Array<TransferTicketFragment> };

export type SaudiRewardsLoyaltyBurnPointsMutationVariables = Exact<{
  input: LoyaltyBurnPointsInput;
}>;


export type SaudiRewardsLoyaltyBurnPointsMutation = { loyaltyBurnPoints?: CartFragment | undefined };

export type SaudiRewardsLoyaltyDeleteBurnPointsMutationVariables = Exact<{
  input: LoyaltyDeleteBurnPointsInput;
}>;


export type SaudiRewardsLoyaltyDeleteBurnPointsMutation = { loyaltyDeleteBurnPoints?: CartFragment | undefined };

export type ApplePayCheckoutFragment = { returnUrl: string };

export type ApplePayCheckoutMutationVariables = Exact<{
  input: ApplePayCheckoutInput;
}>;


export type ApplePayCheckoutMutation = { applePayCheckout?: ApplePayCheckoutFragment | undefined };

export type CartCreateMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  input: CartCreateInput;
}>;


export type CartCreateMutation = { cart?: CartFragment | undefined };

export type CartUpdateMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  input: CartUpdateInput;
}>;


export type CartUpdateMutation = { cart?: CartFragment | undefined };

export type OrderCancelMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderCancelMutation = { orderCancel?: { _?: boolean | undefined } | undefined };

export type OrderCreateMutationVariables = Exact<{
  input: OrderCreateInput;
}>;


export type OrderCreateMutation = { orderCreate?: OrderCheckoutFragment | undefined };

export type SimulateLoyaltyCartUpdateMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  cartItems: Array<SimulateLoyaltyCartItemInput> | SimulateLoyaltyCartItemInput;
}>;


export type SimulateLoyaltyCartUpdateMutation = { simulateLoyaltyCartUpdate: Array<LoyaltyEffectFragment> };

export type TabbyPrescoringFragment = { isCustomerEligible?: boolean | undefined, notEligibleTickets?: Array<string | undefined> | undefined, rejectionReason?: string | undefined };

export type TabbyPrescoringMutationVariables = Exact<{
  input: TabbyPrescoringInput;
}>;


export type TabbyPrescoringMutation = { tabbyPrescoring?: TabbyPrescoringFragment | undefined };

export type TransferAcceptMutationVariables = Exact<{
  input: TransferAcceptInput;
}>;


export type TransferAcceptMutation = { transferAccept?: { _?: boolean | undefined } | undefined };

export type TransferCancelMutationVariables = Exact<{
  input: TransferCancelInput;
}>;


export type TransferCancelMutation = { transferCancel?: { _?: boolean | undefined } | undefined };

export type TransferCreateMutationVariables = Exact<{
  input: TransferCreateInput;
}>;


export type TransferCreateMutation = { transferCreate?: TransferFragment | undefined };

export type TicketDirectionFragment = { title: TranslatedTextFragment, description: TranslatedTextFragment, directionUrl?: TranslatedTextFragment | undefined };

export type TicketTransferInProgressFragment = { receiverName: string, transferId: string, source: TransferSource };

export type TicketBenefitFragment = { type?: string | undefined, value?: number | undefined, causedByLoyaltyTier?: string | undefined, isMultiplier?: boolean | undefined };

export type AccountTicketFragment = { id: string, catalogueTicketId: string, borderColor?: string | undefined, purchaser?: string | undefined, status: AccountEventTicketStatus, parentScannableId?: string | undefined, ticketType?: TicketType | undefined, name: TranslatedTextFragment, timeslots: Array<{ id: string, lastEntryTime: string, dateTimeRange: { start: string, end: string } }>, price?: { amount: number, currency: string } | undefined, ticketDirections?: Array<TicketDirectionFragment> | undefined, scannable: { __typename: 'TicketBarcodeDynamicQrCode', barcode: string, mask: string, publicKey: string, secret: string } | { __typename: 'TicketBarcodeNone' } | { __typename: 'TicketBarcodePdf', pdfTicketId: string } | { __typename: 'TicketBarcodeQrCode', barcode: string, mask: string }, termsAndConditionsUrl?: TranslatedTextFragment | undefined, ticketRestrictions?: Array<{ title: TranslatedTextFragment }> | undefined, ticketAdditionalInfo?: { title: TranslatedTextFragment, description: TranslatedTextFragment } | undefined, transfer: (
    { __typename: 'TicketTransferInProgress' }
    & TicketTransferInProgressFragment
  ) | { __typename: 'TicketTransferNotTransferable', statusReason?: TranslatedTextFragment | undefined } | { __typename: 'TicketTransferable', _?: boolean | undefined }, bookedObject?: BookObjectInfoFragment | undefined, benefits?: Array<TicketBenefitFragment> | undefined };

export type AccountTicketWithChildrenFragment = (
  { children?: Array<AccountTicketFragment | undefined> | undefined }
  & AccountTicketFragment
);

export type AccountEventTicketsGroupedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  timeslotId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AccountEventTicketsGroupedQuery = { accountEventTicketsGrouped: Array<AccountTicketWithChildrenFragment> };

export type AccountEventsOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountEventsOverviewQuery = { accountEventsOverview: Array<{ id: string, ticketCount: number, timeslots: Array<{ id: string, ticketCount: number }> }> };

export type CartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
}>;


export type CartQuery = { cart?: CartFragment | undefined };

export type EventFragment = { id: string, name: TranslatedTextFragment, tickets?: Array<{ id: string, name: { en?: string | undefined }, extraItems?: Array<{ id: string }> | undefined }> | undefined };

export type EventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  timeslotId: Scalars['ID']['input'];
}>;


export type EventQuery = { event?: EventFragment | undefined };

export type EventCategoriesFragment = { id: string, categories?: Array<(
    { children?: Array<EventCategoryFragment> | undefined }
    & EventCategoryFragment
  )> | undefined };

export type EventCategoriesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  timeslotId: Scalars['ID']['input'];
}>;


export type EventCategoriesQuery = { event?: EventCategoriesFragment | undefined };

export type EventLowestPriceFragment = { isAvailable: boolean, ticketId: string, price?: { discountedPrice?: MoneyInfoFragment | undefined, originalPrice: MoneyInfoFragment } | undefined };

export type EventLowestPriceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  timeslotId: Scalars['ID']['input'];
}>;


export type EventLowestPriceQuery = { eventLowestPrice?: EventLowestPriceFragment | undefined };

export type EventTicketQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
}>;


export type EventTicketQuery = { ticket?: TicketFragment | undefined };

export type GeneratingTicketsQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']['input']>;
  timeslotId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GeneratingTicketsQuery = { generatingTickets: boolean };

export type GetTransferQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTransferQuery = { transfer?: { id: string, eventId: string, timeslotIds?: Array<string> | undefined, version: number, status: TransferStatus, senderName?: string | undefined, senderEmail?: string | undefined, receiverName?: string | undefined, receiverEmail?: string | undefined, shareCode: string, tickets: Array<{ id: string, ticketType?: TicketType | undefined, catalogueTicketId?: string | undefined, name: { en?: string | undefined, ar?: string | undefined }, bookedInfo?: { own: string, parent?: string | undefined, section?: string | undefined, label: string, objectType: SeatingObjectType } | undefined }> } | undefined };

export type LoyaltySessionQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type LoyaltySessionQuery = { loyaltySession?: { state?: LoyaltySessionState | undefined, effects: Array<{ name: string, type: string, value: number }> } | undefined };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderQuery = { order?: OrderFragment | undefined };

export type ShareCodeByTransferIdQueryVariables = Exact<{
  transferId: Scalars['ID']['input'];
}>;


export type ShareCodeByTransferIdQuery = { transfer?: TransferFragment | undefined };

export type TicketDownloadUrlQueryVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type TicketDownloadUrlQuery = { ticketDownloadUrl?: { link: string } | undefined };

export type TicketOffersByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  timeslotId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TicketOffersByCodeQuery = { ticketOffersByCode: Array<{ id: string, name: TranslatedTextFragment, tickets: Array<TicketFragment> }> };

export type TicketInfoFragment = { isAvailable: boolean, ticketId: string, paymentMethods: Array<EligiblePaymentMethod>, price?: { originalPrice: MoneyInfoFragment, discountedPrice?: MoneyInfoFragment | undefined } | undefined };

export type TicketsInfoQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TicketsInfoQuery = { ticketsInfo: Array<(
    { ticketId: string }
    & TicketInfoFragment
  )> };

export type TransferTicketFragment = { id: string, name: TranslatedTextFragment, bookedInfo?: BookObjectInfoFragment | undefined };

export type TransferByShareCodeQueryVariables = Exact<{
  shareCode: Scalars['String']['input'];
}>;


export type TransferByShareCodeQuery = { transferByShareCode?: TransferFragment | undefined };

export const MoneyInfoFragmentDoc = gql`
    fragment MoneyInfo on MoneyInfo {
  amount
  currency
}
    ` as unknown as DocumentNode<MoneyInfoFragment, unknown>;
export const CouponCodeFragmentDoc = gql`
    fragment CouponCode on CouponCode {
  code
  discountValue {
    ...MoneyInfo
  }
  couponType
}
    ` as unknown as DocumentNode<CouponCodeFragment, unknown>;
export const TranslatedTextFragmentDoc = gql`
    fragment TranslatedText on TranslatedText {
  en
  ar
}
    ` as unknown as DocumentNode<TranslatedTextFragment, unknown>;
export const CartSubItemFragmentDoc = gql`
    fragment CartSubItem on CartSubItem {
  id
  quantity
}
    ` as unknown as DocumentNode<CartSubItemFragment, unknown>;
export const BookObjectInfoFragmentDoc = gql`
    fragment BookObjectInfo on BookedObject {
  label
  objectType
  parent
  section
  own
}
    ` as unknown as DocumentNode<BookObjectInfoFragment, unknown>;
export const CartItemFragmentDoc = gql`
    fragment CartItem on CartItem {
  id
  catalogueItemId
  discountedItemPrice {
    ...MoneyInfo
  }
  name {
    ...TranslatedText
  }
  originalItemPrice {
    ...MoneyInfo
  }
  subItems {
    ...CartSubItem
  }
  freeItems {
    ...CartSubItem
  }
  quantity
  subtotalPrice {
    ...MoneyInfo
  }
  totalPrice {
    ...MoneyInfo
  }
  bookObjects
  bookedInfo: bookObjectsVerbose {
    ...BookObjectInfo
  }
  state
}
    ` as unknown as DocumentNode<CartItemFragment, unknown>;
export const CartFragmentDoc = gql`
    fragment Cart on Cart {
  id
  cartDiscountPrice {
    ...MoneyInfo
  }
  cartState
  couponCodes {
    ...CouponCode
  }
  subtotalPrice {
    ...MoneyInfo
  }
  subtotalPriceExcluding {
    ...MoneyInfo
  }
  totalPrice {
    ...MoneyInfo
  }
  totalPriceExcluding {
    ...MoneyInfo
  }
  vatAmount {
    ...MoneyInfo
  }
  productsDiscountValue {
    ...MoneyInfo
  }
  items {
    ...CartItem
  }
  modifiers {
    causedByLoyaltyTier
    name
    value
    type
  }
  version
  seatedHoldToken {
    token
    expiresAt
  }
}
    ` as unknown as DocumentNode<CartFragment, unknown>;
export const TranslatedImageUrlFragmentDoc = gql`
    fragment TranslatedImageUrl on TranslatedImageUrl {
  url {
    ...TranslatedText
  }
}
    ` as unknown as DocumentNode<TranslatedImageUrlFragment, unknown>;
export const ImageUrlFragmentDoc = gql`
    fragment ImageUrl on ImageUrl {
  url
}
    ` as unknown as DocumentNode<ImageUrlFragment, unknown>;
export const LoyaltyEffectFragmentDoc = gql`
    fragment LoyaltyEffect on LoyaltyEffect {
  name
  type
  value
}
    ` as unknown as DocumentNode<LoyaltyEffectFragment, unknown>;
export const OrderCheckoutFragmentDoc = gql`
    fragment OrderCheckout on OrderCheckout {
  orderId
  paymentLink
  validationResult
}
    ` as unknown as DocumentNode<OrderCheckoutFragment, unknown>;
export const TicketOrderSubItemFragmentDoc = gql`
    fragment TicketOrderSubItem on CartSubItem {
  id
  quantity
  coverImage {
    url
  }
  name {
    ...TranslatedText
  }
}
    ` as unknown as DocumentNode<TicketOrderSubItemFragment, unknown>;
export const TicketOrderItemFragmentDoc = gql`
    fragment TicketOrderItem on CartItem {
  id
  quantity
  coverImage {
    url
  }
  name {
    ...TranslatedText
  }
  subItems {
    ...TicketOrderSubItem
  }
  freeItems {
    ...TicketOrderSubItem
  }
}
    ` as unknown as DocumentNode<TicketOrderItemFragment, unknown>;
export const OrderTicketFragmentDoc = gql`
    fragment OrderTicket on OrderTicket {
  id
  orderItemId
}
    ` as unknown as DocumentNode<OrderTicketFragment, unknown>;
export const OrderCustomFragmentDoc = gql`
    fragment OrderCustom on OrderCustom {
  saudiRewards {
    type
    points
    membershipId
  }
}
    ` as unknown as DocumentNode<OrderCustomFragment, unknown>;
export const AffiliateSaleFragmentDoc = gql`
    fragment AffiliateSale on AffiliateSale {
  id
  orderId
  partnerId
}
    ` as unknown as DocumentNode<AffiliateSaleFragment, unknown>;
export const OrderFragmentDoc = gql`
    fragment Order on Order {
  id
  eventId
  cartId
  couponCodes {
    ...CouponCode
  }
  items {
    ...CartItem
  }
  totalPrice {
    ...MoneyInfo
  }
  subtotalPrice {
    ...MoneyInfo
  }
  vatAmount {
    ...MoneyInfo
  }
  cartDiscountPrice {
    ...MoneyInfo
  }
  productsDiscountValue {
    ...MoneyInfo
  }
  totalPriceExcluding {
    ...MoneyInfo
  }
  orderTickets {
    ...OrderTicket
  }
  paymentMethod
  custom {
    ...OrderCustom
  }
  state
  affiliateSales {
    ...AffiliateSale
  }
}
    ` as unknown as DocumentNode<OrderFragment, unknown>;
export const TransferTicketFragmentDoc = gql`
    fragment TransferTicket on TransferTicket {
  id
  name {
    ...TranslatedText
  }
  bookedInfo {
    ...BookObjectInfo
  }
}
    ` as unknown as DocumentNode<TransferTicketFragment, unknown>;
export const TransferFragmentDoc = gql`
    fragment Transfer on Transfer {
  id
  eventId
  timeslotIds
  status
  receiverName
  receiverEmail
  senderName
  senderEmail
  shareCode
  tickets {
    ...TransferTicket
  }
  version
}
    ` as unknown as DocumentNode<TransferFragment, unknown>;
export const ApplePayCheckoutFragmentDoc = gql`
    fragment ApplePayCheckout on ApplePayCheckout {
  returnUrl
}
    ` as unknown as DocumentNode<ApplePayCheckoutFragment, unknown>;
export const TabbyPrescoringFragmentDoc = gql`
    fragment TabbyPrescoring on TabbyPrescoring {
  isCustomerEligible
  notEligibleTickets
  rejectionReason
}
    ` as unknown as DocumentNode<TabbyPrescoringFragment, unknown>;
export const TicketDirectionFragmentDoc = gql`
    fragment TicketDirection on TicketDirection {
  title {
    ...TranslatedText
  }
  description {
    ...TranslatedText
  }
  directionUrl {
    ...TranslatedText
  }
}
    ` as unknown as DocumentNode<TicketDirectionFragment, unknown>;
export const TicketTransferInProgressFragmentDoc = gql`
    fragment TicketTransferInProgress on TicketTransferInProgress {
  receiverName
  transferId
  source
}
    ` as unknown as DocumentNode<TicketTransferInProgressFragment, unknown>;
export const TicketBenefitFragmentDoc = gql`
    fragment ticketBenefit on TicketBenefit {
  type
  value
  causedByLoyaltyTier
  isMultiplier
}
    ` as unknown as DocumentNode<TicketBenefitFragment, unknown>;
export const AccountTicketFragmentDoc = gql`
    fragment AccountTicket on AccountEventTicket {
  id
  catalogueTicketId
  name {
    ...TranslatedText
  }
  timeslots {
    id
    dateTimeRange {
      start
      end
    }
    lastEntryTime
  }
  price {
    amount
    currency
  }
  ticketDirections {
    ...TicketDirection
  }
  borderColor
  purchaser
  status
  scannable {
    __typename
    ... on TicketBarcodeDynamicQrCode {
      barcode
      mask
      publicKey
      secret
    }
    ... on TicketBarcodeQrCode {
      barcode
      mask
    }
    ... on TicketBarcodePdf {
      pdfTicketId
    }
  }
  termsAndConditionsUrl {
    ...TranslatedText
  }
  ticketRestrictions {
    title {
      ...TranslatedText
    }
  }
  parentScannableId
  ticketType
  ticketAdditionalInfo {
    title {
      ...TranslatedText
    }
    description {
      ...TranslatedText
    }
  }
  transfer {
    __typename
    ... on TicketTransferInProgress {
      ...TicketTransferInProgress
    }
    ... on TicketTransferNotTransferable {
      statusReason {
        ...TranslatedText
      }
    }
    ... on TicketTransferable {
      _
    }
  }
  bookedObject {
    ...BookObjectInfo
  }
  benefits {
    ...ticketBenefit
  }
}
    ` as unknown as DocumentNode<AccountTicketFragment, unknown>;
export const AccountTicketWithChildrenFragmentDoc = gql`
    fragment AccountTicketWithChildren on AccountEventTicket {
  ...AccountTicket
  children {
    ...AccountTicket
  }
}
    ` as unknown as DocumentNode<AccountTicketWithChildrenFragment, unknown>;
export const EventFragmentDoc = gql`
    fragment Event on Event {
  id
  name {
    ...TranslatedText
  }
  tickets {
    id
    name {
      en
    }
    extraItems {
      id
    }
  }
}
    ` as unknown as DocumentNode<EventFragment, unknown>;
export const PerkFragmentDoc = gql`
    fragment Perk on Perk {
  id
  name {
    ...TranslatedText
  }
}
    ` as unknown as DocumentNode<PerkFragment, unknown>;
export const TicketEmbedFragmentDoc = gql`
    fragment TicketEmbed on Ticket {
  id
  name {
    ...TranslatedText
  }
  description {
    ...TranslatedText
  }
  perks {
    ...Perk
  }
}
    ` as unknown as DocumentNode<TicketEmbedFragment, unknown>;
export const TicketFragmentDoc = gql`
    fragment Ticket on Ticket {
  id
  name {
    ...TranslatedText
  }
  description {
    ...TranslatedText
  }
  perks {
    ...Perk
  }
  extraItems {
    ...TicketEmbed
  }
  isExternalForm
  externalFormUrl {
    ...TranslatedText
  }
  timeslots {
    dateTimeRange {
      start
    }
  }
  seatingData {
    seatingCategoryKey
    seatingChartEventOrSeasonId
  }
}
    ` as unknown as DocumentNode<TicketFragment, unknown>;
export const EventCategoryFragmentDoc = gql`
    fragment EventCategory on EventCategory {
  id
  name {
    ...TranslatedText
  }
  tickets {
    ...Ticket
  }
}
    ` as unknown as DocumentNode<EventCategoryFragment, unknown>;
export const EventCategoriesFragmentDoc = gql`
    fragment EventCategories on Event {
  id
  categories {
    ...EventCategory
    children {
      ...EventCategory
    }
  }
}
    ` as unknown as DocumentNode<EventCategoriesFragment, unknown>;
export const EventLowestPriceFragmentDoc = gql`
    fragment EventLowestPrice on TicketInfo {
  isAvailable
  price {
    discountedPrice {
      ...MoneyInfo
    }
    originalPrice {
      ...MoneyInfo
    }
  }
  ticketId
}
    ` as unknown as DocumentNode<EventLowestPriceFragment, unknown>;
export const TicketInfoFragmentDoc = gql`
    fragment TicketInfo on TicketInfo {
  isAvailable
  ticketId
  paymentMethods
  price {
    originalPrice {
      ...MoneyInfo
    }
    discountedPrice {
      ...MoneyInfo
    }
  }
}
    ` as unknown as DocumentNode<TicketInfoFragment, unknown>;
export const SaudiRewardsLoyaltyBurnPointsDocument = gql`
    mutation saudiRewardsLoyaltyBurnPoints($input: LoyaltyBurnPointsInput!) {
  loyaltyBurnPoints(input: $input) {
    ...Cart
  }
}
    ${CartFragmentDoc}
${MoneyInfoFragmentDoc}
${CouponCodeFragmentDoc}
${CartItemFragmentDoc}
${TranslatedTextFragmentDoc}
${CartSubItemFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<SaudiRewardsLoyaltyBurnPointsMutation, SaudiRewardsLoyaltyBurnPointsMutationVariables>;
export const SaudiRewardsLoyaltyDeleteBurnPointsDocument = gql`
    mutation saudiRewardsLoyaltyDeleteBurnPoints($input: LoyaltyDeleteBurnPointsInput!) {
  loyaltyDeleteBurnPoints(input: $input) {
    ...Cart
  }
}
    ${CartFragmentDoc}
${MoneyInfoFragmentDoc}
${CouponCodeFragmentDoc}
${CartItemFragmentDoc}
${TranslatedTextFragmentDoc}
${CartSubItemFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<SaudiRewardsLoyaltyDeleteBurnPointsMutation, SaudiRewardsLoyaltyDeleteBurnPointsMutationVariables>;
export const ApplePayCheckoutDocument = gql`
    mutation applePayCheckout($input: ApplePayCheckoutInput!) {
  applePayCheckout(input: $input) {
    ...ApplePayCheckout
  }
}
    ${ApplePayCheckoutFragmentDoc}` as unknown as DocumentNode<ApplePayCheckoutMutation, ApplePayCheckoutMutationVariables>;
export const CartCreateDocument = gql`
    mutation cartCreate($eventId: ID!, $input: CartCreateInput!) {
  cart: cartCreate(input: $input, eventId: $eventId) {
    ...Cart
  }
}
    ${CartFragmentDoc}
${MoneyInfoFragmentDoc}
${CouponCodeFragmentDoc}
${CartItemFragmentDoc}
${TranslatedTextFragmentDoc}
${CartSubItemFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<CartCreateMutation, CartCreateMutationVariables>;
export const CartUpdateDocument = gql`
    mutation cartUpdate($cartId: ID!, $eventId: ID!, $input: CartUpdateInput!) {
  cart: cartUpdate(cartId: $cartId, eventId: $eventId, input: $input) {
    ...Cart
  }
}
    ${CartFragmentDoc}
${MoneyInfoFragmentDoc}
${CouponCodeFragmentDoc}
${CartItemFragmentDoc}
${TranslatedTextFragmentDoc}
${CartSubItemFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<CartUpdateMutation, CartUpdateMutationVariables>;
export const OrderCancelDocument = gql`
    mutation orderCancel($orderId: ID!) {
  orderCancel(orderId: $orderId) {
    _
  }
}
    ` as unknown as DocumentNode<OrderCancelMutation, OrderCancelMutationVariables>;
export const OrderCreateDocument = gql`
    mutation orderCreate($input: OrderCreateInput!) {
  orderCreate(input: $input) {
    ...OrderCheckout
  }
}
    ${OrderCheckoutFragmentDoc}` as unknown as DocumentNode<OrderCreateMutation, OrderCreateMutationVariables>;
export const SimulateLoyaltyCartUpdateDocument = gql`
    mutation simulateLoyaltyCartUpdate($cartId: ID!, $cartItems: [SimulateLoyaltyCartItemInput!]!) {
  simulateLoyaltyCartUpdate(cartId: $cartId, cartItems: $cartItems) {
    ...LoyaltyEffect
  }
}
    ${LoyaltyEffectFragmentDoc}` as unknown as DocumentNode<SimulateLoyaltyCartUpdateMutation, SimulateLoyaltyCartUpdateMutationVariables>;
export const TabbyPrescoringDocument = gql`
    mutation tabbyPrescoring($input: TabbyPrescoringInput!) {
  tabbyPrescoring(input: $input) {
    ...TabbyPrescoring
  }
}
    ${TabbyPrescoringFragmentDoc}` as unknown as DocumentNode<TabbyPrescoringMutation, TabbyPrescoringMutationVariables>;
export const TransferAcceptDocument = gql`
    mutation TransferAccept($input: TransferAcceptInput!) {
  transferAccept(input: $input) {
    _
  }
}
    ` as unknown as DocumentNode<TransferAcceptMutation, TransferAcceptMutationVariables>;
export const TransferCancelDocument = gql`
    mutation transferCancel($input: TransferCancelInput!) {
  transferCancel(input: $input) {
    _
  }
}
    ` as unknown as DocumentNode<TransferCancelMutation, TransferCancelMutationVariables>;
export const TransferCreateDocument = gql`
    mutation transferCreate($input: TransferCreateInput!) {
  transferCreate(input: $input) {
    ...Transfer
  }
}
    ${TransferFragmentDoc}
${TransferTicketFragmentDoc}
${TranslatedTextFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<TransferCreateMutation, TransferCreateMutationVariables>;
export const AccountEventTicketsGroupedDocument = gql`
    query accountEventTicketsGrouped($id: ID!, $timeslotId: ID) {
  accountEventTicketsGrouped(id: $id, timeslotId: $timeslotId) {
    ...AccountTicketWithChildren
  }
}
    ${AccountTicketWithChildrenFragmentDoc}
${AccountTicketFragmentDoc}
${TranslatedTextFragmentDoc}
${TicketDirectionFragmentDoc}
${TicketTransferInProgressFragmentDoc}
${BookObjectInfoFragmentDoc}
${TicketBenefitFragmentDoc}` as unknown as DocumentNode<AccountEventTicketsGroupedQuery, AccountEventTicketsGroupedQueryVariables>;
export const AccountEventsOverviewDocument = gql`
    query accountEventsOverview {
  accountEventsOverview {
    id
    ticketCount
    timeslots {
      id
      ticketCount
    }
  }
}
    ` as unknown as DocumentNode<AccountEventsOverviewQuery, AccountEventsOverviewQueryVariables>;
export const CartDocument = gql`
    query cart($cartId: ID!, $eventId: ID!) {
  cart(cartId: $cartId, eventId: $eventId) {
    ...Cart
  }
}
    ${CartFragmentDoc}
${MoneyInfoFragmentDoc}
${CouponCodeFragmentDoc}
${CartItemFragmentDoc}
${TranslatedTextFragmentDoc}
${CartSubItemFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<CartQuery, CartQueryVariables>;
export const EventDocument = gql`
    query event($id: ID!, $timeslotId: ID!) {
  event(id: $id, timeslotId: $timeslotId) {
    ...Event
  }
}
    ${EventFragmentDoc}
${TranslatedTextFragmentDoc}` as unknown as DocumentNode<EventQuery, EventQueryVariables>;
export const EventCategoriesDocument = gql`
    query eventCategories($id: ID!, $timeslotId: ID!) {
  event(id: $id, timeslotId: $timeslotId) {
    ...EventCategories
  }
}
    ${EventCategoriesFragmentDoc}
${EventCategoryFragmentDoc}
${TranslatedTextFragmentDoc}
${TicketFragmentDoc}
${PerkFragmentDoc}
${TicketEmbedFragmentDoc}` as unknown as DocumentNode<EventCategoriesQuery, EventCategoriesQueryVariables>;
export const EventLowestPriceDocument = gql`
    query eventLowestPrice($id: ID!, $timeslotId: ID!) {
  eventLowestPrice(id: $id, timeslotId: $timeslotId) {
    ...EventLowestPrice
  }
}
    ${EventLowestPriceFragmentDoc}
${MoneyInfoFragmentDoc}` as unknown as DocumentNode<EventLowestPriceQuery, EventLowestPriceQueryVariables>;
export const EventTicketDocument = gql`
    query eventTicket($eventId: ID!, $ticketId: ID!) {
  ticket(eventId: $eventId, ticketId: $ticketId) {
    ...Ticket
  }
}
    ${TicketFragmentDoc}
${TranslatedTextFragmentDoc}
${PerkFragmentDoc}
${TicketEmbedFragmentDoc}` as unknown as DocumentNode<EventTicketQuery, EventTicketQueryVariables>;
export const GeneratingTicketsDocument = gql`
    query generatingTickets($eventId: ID, $timeslotId: ID) {
  generatingTickets(eventId: $eventId, timeslotId: $timeslotId)
}
    ` as unknown as DocumentNode<GeneratingTicketsQuery, GeneratingTicketsQueryVariables>;
export const GetTransferDocument = gql`
    query getTransfer($id: ID!) {
  transfer(id: $id) {
    id
    eventId
    timeslotIds
    version
    status
    senderName
    senderEmail
    receiverName
    receiverEmail
    shareCode
    tickets {
      id
      name {
        en
        ar
      }
      ticketType
      catalogueTicketId
      bookedInfo {
        own
        parent
        section
        label
        objectType
      }
    }
  }
}
    ` as unknown as DocumentNode<GetTransferQuery, GetTransferQueryVariables>;
export const LoyaltySessionDocument = gql`
    query loyaltySession($cartId: ID!) {
  loyaltySession(cartId: $cartId) {
    effects {
      name
      type
      value
    }
    state
  }
}
    ` as unknown as DocumentNode<LoyaltySessionQuery, LoyaltySessionQueryVariables>;
export const OrderDocument = gql`
    query order($orderId: ID!) {
  order(orderId: $orderId) {
    ...Order
  }
}
    ${OrderFragmentDoc}
${CouponCodeFragmentDoc}
${MoneyInfoFragmentDoc}
${CartItemFragmentDoc}
${TranslatedTextFragmentDoc}
${CartSubItemFragmentDoc}
${BookObjectInfoFragmentDoc}
${OrderTicketFragmentDoc}
${OrderCustomFragmentDoc}
${AffiliateSaleFragmentDoc}` as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const ShareCodeByTransferIdDocument = gql`
    query shareCodeByTransferId($transferId: ID!) {
  transfer(id: $transferId) {
    ...Transfer
  }
}
    ${TransferFragmentDoc}
${TransferTicketFragmentDoc}
${TranslatedTextFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<ShareCodeByTransferIdQuery, ShareCodeByTransferIdQueryVariables>;
export const TicketDownloadUrlDocument = gql`
    query ticketDownloadUrl($ticketId: ID!) {
  ticketDownloadUrl(pdfTicketId: $ticketId) {
    link
  }
}
    ` as unknown as DocumentNode<TicketDownloadUrlQuery, TicketDownloadUrlQueryVariables>;
export const TicketOffersByCodeDocument = gql`
    query ticketOffersByCode($code: String!, $eventId: ID!, $timeslotId: ID) {
  ticketOffersByCode(code: $code, eventId: $eventId, timeslotId: $timeslotId) {
    id
    name {
      ...TranslatedText
    }
    tickets {
      ...Ticket
    }
  }
}
    ${TranslatedTextFragmentDoc}
${TicketFragmentDoc}
${PerkFragmentDoc}
${TicketEmbedFragmentDoc}` as unknown as DocumentNode<TicketOffersByCodeQuery, TicketOffersByCodeQueryVariables>;
export const TicketsInfoDocument = gql`
    query ticketsInfo($eventId: ID!, $ticketIds: [ID!]!) {
  ticketsInfo(eventId: $eventId, ticketIds: $ticketIds) {
    ...TicketInfo
    ticketId
  }
}
    ${TicketInfoFragmentDoc}
${MoneyInfoFragmentDoc}` as unknown as DocumentNode<TicketsInfoQuery, TicketsInfoQueryVariables>;
export const TransferByShareCodeDocument = gql`
    query TransferByShareCode($shareCode: String!) {
  transferByShareCode(shareCode: $shareCode) {
    ...Transfer
  }
}
    ${TransferFragmentDoc}
${TransferTicketFragmentDoc}
${TranslatedTextFragmentDoc}
${BookObjectInfoFragmentDoc}` as unknown as DocumentNode<TransferByShareCodeQuery, TransferByShareCodeQueryVariables>;